<template lang="pug">
  div
    // Loading state
    .d-flex.justify-center(v-if="!databinKey")
      v-progress-circular(indeterminate size="40" color="primary")

    // QR Code only
    div(v-else)
      vue-qrcode(:value="qrUrl" :options="qrOptions" tag="canvas")
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import axios from 'axios'

export default {
  name: 'YzUploadQrDatabin',
  components: {
    VueQrcode
  },
  props: {
    // QR code configuration
    qrSize: {
      type: Number,
      default: 120
    },
    // Databin TTL in seconds
    ttl: {
      type: Number,
      default: 900
    },
    // Auto-start databin creation
    autoStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      databinKey: null,
      isCreating: false
    }
  },
  computed: {
    qrUrl() {
      if (!this.databinKey) return null
      return encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/upload-photo/${this.databinKey}`)
    },
    qrOptions() {
      return {
        width: this.qrSize,
        height: this.qrSize,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      }
    }
  },
  mounted() {
    if (this.autoStart) {
      this.createDatabin()
    }
  },
  beforeDestroy() {
    // Cleanup databin if needed
    this.databinKey = null
  },
  methods: {
    // Create databin via API
    async createDatabin() {
      if (this.isCreating || this.databinKey) return

      try {
        this.isCreating = true
        const response = await axios.post(`/databin/?ttl=${this.ttl}`)
        this.databinKey = response.data.key

        this.$emit('databin-created', {
          key: this.databinKey,
          url: this.qrUrl
        })
      } catch (error) {
        this.$emit('error', {
          message: 'Failed to create databin',
          error
        })
      } finally {
        this.isCreating = false
      }
    },

    // Public method to manually create databin
    async initialize() {
      return this.createDatabin()
    },

    // Get current databin key
    getDatabinKey() {
      return this.databinKey
    }
  }
}
</script>

<style scoped>
</style>